import React from 'react';
import Button from '@mui/material/Button'
function CreateUser() {
  return <div>
      <Button>Create user</Button>
  </div>;
}

export default CreateUser;
